module.exports = __webpack_public_path__ + "img/pos_custom0.bff580bc.png";